import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';

const downloadDataFromS3 = async (key: string): Promise<any> => {
  try {
    const url = `https://s3.basse.io/${key}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    throw error;
  }
};

const uploadDataToS3 = async (key: string, data: any): Promise<string> => {
  const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
  const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
  const region = process.env.REACT_APP_AWS_REGION;
  const bucketName = process.env.REACT_APP_S3_BUCKET_NAME;

  if (!accessKeyId || !secretAccessKey || !region || !bucketName) {
    throw new Error('Upload functionality requires full AWS credentials configuration');
  }

  try {
    const s3Client = new S3Client({
      region,
      credentials: {
        accessKeyId,
        secretAccessKey,
      },
    });

    const command = new PutObjectCommand({
      Bucket: bucketName,
      Key: key,
      Body: JSON.stringify(data, null, 2),
      ContentType: 'application/json',
    });

    await s3Client.send(command);

    return `https://${bucketName}.s3.${region}.amazonaws.com/${key}`;
  } catch (error) {
    throw error;
  }
};

export { downloadDataFromS3, uploadDataToS3 };
